import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '@/hooks/useAppSelector';
import LandingPage from '@/pages/LandingPage';

/**
 * Raiz pública: usuário deslogado vê a landing de vendas;
 * logado é levado direto ao dashboard.
 */
const RootGate: React.FC = () => {
  const isAuthenticated = useAppSelector((s) => s.auth.isAuthenticated);
  return isAuthenticated ? <Navigate to="/dashboard" replace /> : <LandingPage />;
};

export default RootGate;
